import React from "react";

export default function DiscountDialog({
  isOpen,
  store,
  discount,
  onChangeDiscount,
  onClose,
  calculatePrice,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6 mx-4">
        {/* Header */}
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="text-lg font-semibold">Apply Discount</h3>
            <p className="text-sm text-gray-500">
              Apply a percentage discount to {store?.name}'s plan.
            </p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        {/* Body */}
        <div className="grid gap-4 py-4">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">Current Price:</span>
            <span className="font-semibold">{store?.payment}</span>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex-1">
              <label htmlFor="discount" className="text-sm font-medium mb-1 block">
                Discount (%)
              </label>
              <input
                id="discount"
                type="number"
                min="0"
                max="100"
                placeholder="e.g. 20"
                value={discount}
                onChange={(e) => onChangeDiscount(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#2962FF]"
              />
            </div>
          </div>
          <div className="flex items-center justify-between mt-2 p-3 bg-gray-50 rounded-md">
            <span className="text-sm font-medium">Price after discount:</span>
            <span className="font-semibold text-[#2962FF]">
              {store ? calculatePrice(store.payment, discount) : "$0.00"}
            </span>
          </div>
        </div>
        {/* Footer */}
        <div className="flex justify-end gap-3 mt-4">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-[#2962FF] text-white rounded-md hover:bg-blue-600 transition-colors"
            onClick={onClose}
          >
            Apply Discount
          </button>
        </div>
      </div>
    </div>
  );
}
